import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface InternalStateType {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class AppState {
  public loading = false;

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  changeLang(lang: string) {
    this.translate.use(lang);
  }


  clearLocalStorage(): void {
    localStorage.removeItem('selectedPlan');
    localStorage.removeItem('selectedArea');
  }
}
